import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Privacidad = () => {
  return (
    <div className="py-16 relative">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold mb-8 text-center">Política de Privacidad</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Responsable del Tratamiento</h2>
            <p className="text-gray-700 mb-4">
              La empresa VGBComputers, con domicilio en Santa Cruz de Tenerife, es responsable del tratamiento de los datos personales del Usuario y le informa que estos datos serán tratados de conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril (GDPR), y la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD).
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Finalidad del Tratamiento</h2>
            <p className="text-gray-700 mb-4">
              La finalidad del tratamiento es la gestión de los datos proporcionados por los usuarios a través del sitio web para:
            </p>
            <ul className="list-disc ml-6 text-gray-700 mb-4">
              <li>Gestionar las solicitudes de información recibidas a través de los formularios de contacto</li>
              <li>Enviar comunicaciones comerciales sobre nuestros productos y servicios</li>
              <li>Prestar los servicios contratados</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Legitimación del Tratamiento</h2>
            <p className="text-gray-700 mb-4">
              La base legal para el tratamiento de los datos es el consentimiento del usuario al comunicarse con nosotros, la ejecución de un contrato en el que el interesado es parte, o para la aplicación de medidas precontractuales.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Conservación de los Datos</h2>
            <p className="text-gray-700 mb-4">
              Los datos se conservarán mientras exista un interés mutuo para mantener la finalidad del tratamiento, o durante el tiempo necesario para cumplir con las obligaciones legales.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Comunicación de los Datos</h2>
            <p className="text-gray-700 mb-4">
              No se comunicarán los datos a terceros, salvo obligación legal o para la prestación del servicio.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Derechos de los Usuarios</h2>
            <p className="text-gray-700 mb-4">
              Los usuarios tienen derecho a:
            </p>
            <ul className="list-disc ml-6 text-gray-700">
              <li>Solicitar el acceso a sus datos personales</li>
              <li>Solicitar su rectificación o supresión</li>
              <li>Solicitar la limitación de su tratamiento</li>
              <li>Oponerse al tratamiento</li>
              <li>Solicitar la portabilidad de los datos</li>
              <li>Retirar el consentimiento en cualquier momento</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-4 text-blue-600">Contacto</h2>
            <p className="text-gray-700">
              Para ejercer sus derechos, puede enviar un correo electrónico a info@vgbcomputers.com, adjuntando copia de su DNI.
            </p>
          </div>
        </div>
      </div>
      
      {/* Botón para volver arriba */}
      <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Privacidad;